import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import format from './l10n/locale-format';
import languages from './languages';
import LanguageDetector from 'i18next-browser-languagedetector';

const ns = [
  'common',
  'about',
  'audit_log',
  'autoonboard_common',
  'autoonboard_time',
  'dimension',
  'autoonboard_account_group_mapping',
  'autoonboard_review_data',
  'autoonboard_create_budget',
  'jobs',
  'onboard',
  'menu',
  'contentagreement',
  'glsettings',
  'writeback',
  'account_setup_status',
  'webhooklogqueue',
  'forecast',
  'error',
  'release_notes',
  'copyversion',
  'version_locking',
];

const mapLanguages = () => {
  let resources = {};
  languages.forEach(item => {
    let lng = {};
    ns.forEach(e => {
      lng[e] = require(`../../../assets/translations/i18n/${e}/angular-locale_en-us.json`);
    });
    resources[item.id.split('-')[0]] = lng;
  });
  return resources;
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en-us',
    resources: mapLanguages(),
    ns,
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
      format,
    },
  });

i18n.languages = languages.map(item => item.id);

export default i18n;
